import { IParsedDo, IPitch } from "../types";

type IExtendedPitch = IPitch & { do?: IParsedDo}
const getNoteAssets = (note: IExtendedPitch) => {
    let i = Number((((note.s - 1) * 7) % 12) + (note.a || 0) + (note.o || 0) * 12);
    if (note.s === 0) i += 12;
    let r = Number((((note.s - 1) * 4) % 7) + (note.o || 0) * 7);
    if (note.s === 0) r += 7;
    return [i, r];
};

const keyIntervals = {
    "8": 13,
    "7": 12,
    "6": 10,
    "5": 8,
    "4": 6,
    "3": 5,
    "2": 3,
    "1": 1,
    "0": 0,
    "-1": -2,
    "-2": -4,
    "-3": -6,
    "-4": -7,
    "-5": -9,
    "-6": -11,
    "-7": -12,
    "-8": -14,
    "-9": -16,
    "-10": -18,
    "-11": -19,
    "-12": -21,
    "-13": -23,
    "-14": -24,
    "-15": -26,
    "-16": -28,
};

export default (noteA: IExtendedPitch, noteB: IExtendedPitch) => {
    let differenceR: number = 0;
    let differenceI: number = 0;
    if (noteA.do && noteB.do) {
        differenceR = noteA.do.value - noteB.do.value;
        differenceI = (keyIntervals[noteA.do.value] + (noteA.do.alt || 0)) - (keyIntervals[noteB.do.value] + (noteB.do.alt || 0))
    }
    const [iA, rA] = getNoteAssets(noteA);
    const [iB, rB] = getNoteAssets(noteB);
    let i = Math.abs(iA - iB + differenceI);
    let r = Math.abs(rA - rB + differenceR);
    return {
        i,
        r,
    };
};
